import { prefixObjectValues } from '../../utils';

const form = {
  shiftDiffType: 'shift-diff-type',
  numDayCallShifts: 'num-day-call-shifts',
  numEveCallShifts: 'num-eve-call-shifts',
  numNightCallShifts: 'num-night-call-shifts',
  numOfWeDayCallShifts: 'num-of-we-day-call-shifts',
  numOfWeEveCallShifts: 'num-of-we-eve-call-shifts',
  numOfWeNightCallShifts: 'num-of-we-night-call-shifts',
  numHolDayCallShifts: 'num-of-hol-day-call-shifts',
  numHolEveCallShifts: 'num-of-hol-eve-call-shifts',
  numHolNightCallShifts: 'num-of-hol-night-call-shifts',
  dayCallShiftRateDiff: 'day-call-shift-rate-diff',
  eveCallShiftRateDiff: 'eve-call-shift-rate-diff',
  nightCallShiftRateDiff: 'night-call-shift-rate-diff',
  weDayCallShiftRateDiff: 'we-day-call-shift-rate-diff',
  weEveCallShiftRateDiff: 'we-eve-call-shift-rate-diff',
  weNightCallShiftRateDiff: 'we-night-call-shift-rate-diff',
  holDayCallShiftRateDiff: 'hol-day-call-shift-rate-diff',
  holEveCallShiftRateDiff: 'hol-eve-call-shift-rate-diff',
  holNightCallShiftRateDiff: 'hol-night-call-shift-rate-diff',
};

export default prefixObjectValues(form, 'on-call-shift-details-form');
